import './index.less';

import common from './common/index';

const api = {
  sendSmsKey: {
    url: '/api/sms/getPublicKey'
  },

  sendSms: {
    url: '/api/sms/sendMessage',
    intercept: {
      request(config) {
        // +SmsKey
        return new Promise((resolve) => {
          api.sendSmsKey.fetch({
            data: { mobile: config.data.mobile },
            success: (data) => {
              config.data.publicKey = data;
              resolve(config);
            }
          });
        });
      }
    }
  },

  login: {
    url: '/api/member/loginWithMobile'
  },

  logout: {
    url: '/api/auth/logout'
  },

  userinfo: {
    token: true,
    url: '/api/member/getMemberInfo'
    // intercept: {
    //   response(response) {
    //     return new Promise((resolve) => {
    //       api.userSig.fetch({
    //         data: {
    //           siteId: $$.module.data.room.siteId
    //         },
    //         success: (sign) => {
    //           console.log('sign', sign);
    //           Object.assign(response.data.data, sign);
    //           resolve(response);
    //         }
    //       });
    //     });
    //   }
    // }
  },

  // room
  room: {
    token: true,
    url: `/api/room/${$$.util.getParam('mode') || 'interview'}/getCompleteRoomInfo`
    // intercept: {
    //   response(response) {
    //     const data = response.data.data;
    //     // // +RoomGuideInfo [引导页是否开启 + 直播状态 data.liveState]
    //     return new Promise((resolve) => {
    //       if (data.guideFlag === '0' && data.liveState === '1') {
    //         api.roomGuideInfo.fetch({
    //           data: { roomId: data.roomId },
    //           success: (guideInfo) => {
    //             data.guideInfo = guideInfo;
    //             resolve(response);
    //           }
    //         });
    //       } else {
    //         resolve(response);
    //       }
    //     });
    //   }
    // }
  },

  getRoomAuth: {
    url: '/api/room/interview/getRoomAuth'
  },

  userSig: {
    token: true,
    url: '/api/member/getUserSig'
  },
  roomGuideInfo: {
    token: true,
    url: '/api/room/getGuideInfo'
  },
  getTmpUserImLogin: {
    url: '/api/member/getTmpUserImLogin'
  }
};

export default {
  name: 'core',
  api,
  children: [common],
  install: (path) => {
    return import(/* webpackMode: "eager" */ `./${path}.vue`);
  }
};
